export default {
    'privacy.title': 'นโยบายความเป็นส่วนตัว',
} as Record<string, string>;

